import { Link as LinkR } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Nav = styled.nav`
    background: rgba(10, 10, 26, 0.85);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    border-bottom: 1px solid rgba(133, 76, 230, 0.08);
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 100;
    transition: all 0.3s ease;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;

export const NavLogo = styled(LinkR)`
    display: flex;
    align-items: center;
    text-decoration: none;
    flex-shrink: 0;
`;

export const Span = styled.div`
    padding: 0 4px;
    font-weight: bold;
    font-size: 18px;
`;

export const NavItems = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    list-style: none;
    margin: 0;
    padding: 0;

    @media screen and (max-width: 768px) {
      display: none;
    }
`;

export const NavLink = styled.a`
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    padding: 8px 14px;
    border-radius: 8px;
    letter-spacing: 0.2px;

    &:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.06);
    }

    &.active {
      color: ${({ theme }) => theme.primary};
      background: rgba(133, 76, 230, 0.1);
    }
`;

export const GitHubButton = styled.a`
  background: ${({ theme }) => theme.primary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  padding: 8px 18px;
  font-weight: 600;
  text-decoration: none;
  font-size: 13px;
  letter-spacing: 0.3px;
  transition: all 0.25s ease;
  white-space: nowrap;
  border: none;
  flex-shrink: 0;

  &:hover {
    background: #9b6ce8;
    box-shadow: 0 4px 20px rgba(133, 76, 230, 0.35);
    transform: translateY(-1px);
  }

  @media screen and (max-width: 768px) {
    font-size: 13px;
    padding: 10px 20px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    transition: color 0.2s ease;
    padding: 4px;

    &:hover {
      color: #fff;
    }
  }
`;

export const MobileOverlay = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 99;
  }
`;

export const MobileMenu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    width: 100%;
    padding: 16px 24px 24px;
    background: rgba(10, 10, 26, 0.98);
    border-bottom: 1px solid rgba(133, 76, 230, 0.15);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
    animation: ${slideDown} 0.25s ease forwards;
    z-index: 1000;
`;

export const MobileLink = styled.a`
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 8px;
  width: 100%;
  text-align: center;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.06);
  }
`;
